import React from "react";
import { connect } from "react-redux";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";

const DevelopmentBalance = ({ developmentBalance }) => (
  <React.Fragment>
    <h3 className="title">Development progress</h3>

    Buildings: <span className={developmentBalance.buildings ? "positive" : ""}>{formatNumberForceSigned(developmentBalance.buildings)}</span><br/>
    {developmentBalance.race
      ? <>Race bonus: <span className="positive">{formatNumberForceSigned(developmentBalance.race)}</span><br/></> : ""}
    General: <span className={developmentBalance.general ? "positive" : ""}>{formatNumberForceSigned(developmentBalance.general)}</span><br/>
    {developmentBalance.bankruptcy
      ? <>Bankruptcy: <span className="negative">{developmentBalance.bankruptcy}</span><br/></> : ""}
    Happiness: <span
    className={developmentBalance.happiness < 0 ? "negative" : "positive"}>{formatNumberForceSigned(developmentBalance.happiness)}</span><br/>
  </React.Fragment>
);

const mapStateToProps = state => ({
  developmentBalance: state.governorate.resourceBalances.development,
});

export default connect(mapStateToProps)(DevelopmentBalance);
